"use client";

import { Apple } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Announcement() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="announcement" className="dark bg-background text-foreground py-32 md:py-40 relative overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] md:w-[800px] h-[400px] bg-primary/15 rounded-[100%] blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`max-w-4xl mx-auto text-center p-8 md:p-16 rounded-3xl bg-card/40 backdrop-blur-xl border border-border/50 shadow-2xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <Badge variant="outline" className="mb-8 border-primary/30 text-primary bg-primary/10 px-4 py-1.5 text-sm rounded-full font-sans">
            Coming Soon
          </Badge>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black font-default tracking-tight mb-6 text-balance">
            Coming soon on the App Store
          </h2>

          <p className="text-lg md:text-xl text-muted-foreground mb-10 font-sans max-w-2xl mx-auto text-balance">
            Be among the first to try HalfOrder in Toronto. Share meals, split
            costs, and connect with others nearby.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="rounded-md h-14 px-8 text-lg font-semibold shadow-[0_0_24px_-4px_var(--color-primary)] hover:shadow-[0_0_32px_-4px_var(--color-primary)] transition-shadow duration-300 w-full sm:w-auto">
              <Link to="#">
                <Apple className="mr-2 size-6" />
                Join the Waitlist
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}